module.exports = __webpack_public_path__ + "static/media/background-orange.b8724864.jpg";